// src/views/ThankYou.js
import React, { useEffect } from "react";
import { useLocation, Navigate } from "react-router-dom";
import Layout from "../components/layoutBlack";
import ReactGA from "react-ga4";

function ThankYou() {
  const location = useLocation();
  const { state } = location;
  const { cart, invoiceNumber, shippingAddress } = state;

useEffect(() => {
  if (cart?.total_price > 0) {
    ReactGA.event({
      category: 'Sales',
      action: 'cart purchase',
      label: 'Sale Form',
      value: Math.round(cart.total_price), // GA expects integer
    });
  }
}, []); // only run once when component mounts


  // If the user accesses this page directly, redirect to home
  if (!state || !state.cart || !state.invoiceNumber) {
    return <Navigate to="/" />;
  }

    return (
    <Layout>
      <section className="full-page-section bg0 p-t-120 p-b-80">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <h2 className="mb-3">Thank you for your order!</h2>
              <p className="lead">Your order has been placed successfully.</p>

              <div className="border rounded p-4 bg-light my-4 text-start">
                <h5 className="mb-3">Order Summary</h5>
                <p><strong>Invoice Number:</strong> {invoiceNumber}</p>

                <h6 className="mt-4">Items Ordered:</h6>
                <ul className="list-group mb-3">
                  {cart.items.map((item) => (
                    <li className="list-group-item d-flex justify-content-between" key={item.id}>
                      <div>
                        <strong>{item.name}</strong><br />
                        <small>Qty: {item.quantity}</small>
                      </div>
                      <div>${(item.quantity * item.price).toFixed(2)}</div>
                    </li>
                  ))}
                </ul>

                <h6>Shipping Address:</h6>
                {shippingAddress ? (
                  <p>
                    {shippingAddress.address1}<br />
                    {shippingAddress.address2 && <>{shippingAddress.address2}<br /></>}
                    {shippingAddress.city}, {shippingAddress.state}<br />
                    {shippingAddress.country}
                  </p>
                ) : (
                  <p><em>No address available</em></p>
                )}

                <p className="mt-3">
                </p>
                <p className="mt-3">
                  Sub Total: ${Number(cart.subtotal || 0).toFixed(2)}<br/>
                  Shipping: ${Number(cart.shipping_price || 0).toFixed(2)}<br/>
                  Discount: <strong className="text-success">-${parseFloat(cart.discount_value).toFixed(2)}</strong><br/>
                  <strong>Total Paid:</strong> ${Number(cart.total_price || 0).toFixed(2)}
                </p>
              </div>

              <p className="mt-4">You’ll receive an email confirmation shortly.</p>
              <p>We’ll notify you again once your item ships.</p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default ThankYou;
